import { VehicleAllocation } from '@/types/vehicleAllocation'
import styles from './VehicleAllocationColumn.module.scss'
import { DndContextAllocation } from './dnd/DndContextAllocation'
import { DragOverlayAllocation } from './dnd/DragOverlayAllocation'
import { VehicleAllocationItem } from './AllocationItem/VehicleAllocationItem'
import { ColumnHeader } from './AllocationItem/ColumnHeader'
import { SwappedBus } from './AllocationItem/SwappedBus'
import { useEffect } from 'react'
import { useVehicleAllocationStore } from '../../store'
import DisruptionIcon from '../../assets/disruption.svg'

export const VehicleAllocationColumn = ({ allocation }: { allocation: VehicleAllocation }) => {
    const { swappedBuses, routeEditing } = useVehicleAllocationStore()

    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            if (routeEditing) {
                event.preventDefault()
                event.returnValue = 'Leave site? Changes that you made may not be saved.'
                // The string is required for some browsers, but most will show a generic message
            }
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [routeEditing])

    const isAllBonnetsEmpty = allocation.allocations.every((allocationItem) => allocationItem.bonnet === null)

    return (
        <div className={styles.column}>
            <span className={styles.routeLabel}>{allocation.route}</span>

            {isAllBonnetsEmpty && (
                <span className={styles.dataError}>
                    <DisruptionIcon />
                    Run out data expected soon
                </span>
            )}

            <div className={styles.container}>
                <ColumnHeader allocation={allocation} />

                <DndContextAllocation>
                    {allocation.allocations.map((allocationItem) => (
                        <VehicleAllocationItem
                            key={allocationItem.run}
                            allocation={allocationItem}
                            allAllocations={allocation.allocations}
                            route={allocation.route}
                        />
                    ))}

                    <DragOverlayAllocation allocation={allocation} route={allocation.route} />
                </DndContextAllocation>

                {routeEditing === allocation.route && swappedBuses.length > 0 && (
                    <>
                        <div className={styles.swappedBusesLabel}>Swapped buses</div>
                        {swappedBuses.map((bus) => (
                            <SwappedBus
                                key={bus}
                                allocation={{
                                    run: '-',
                                    bonnet: bus,
                                    additionalData: {
                                        history: [],
                                        timeOut: null,
                                        remarks: null,
                                        changedAt: null,
                                    },
                                }}
                            />
                        ))}
                    </>
                )}
            </div>
        </div>
    )
}
